import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/cuentaunicasir/tipos-de-considerados';

/**
 * GET Tipos de Considerado
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeConsiderados = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data.filter((e) => e.estados_globales !== 5);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Considerado
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoConsiderado = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Considerado
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoConsiderado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Considerado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoConsiderado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Considerado
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoConsiderado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
